(function () {
  let excludeColumn = null;

  // 排除数值转换
  const exclude_title = ['NUMERISCHE GRÖSSE', 'NUMERIC SIZE']
  let metafieldData = {}
  try {
    metafieldData = JSON.parse($(".pr_metafield_json").html() || '{}')
  } catch (error) {
    console.warn('Invalid product metafield data:', error)
  }
  const operation_filter = metafieldData.operation_filter

  function changeUnit(row, column, value, unit = "inch") {
    const type = $(".mibao_size_guide_2022 .guide_table .header .hit").attr(
      "type"
    );
    const d = 2.54;
    const re1 = new RegExp(/^(\d+(\.\d+)?)-(\d+(\.\d+)?)$/);
    if ((type == "body" && row != 1) || (type == "product" && row != 1)) {
      // 排除 NUMERIC SIZE 的数值转换
      if (exclude_title.find((title) => {
        return value.includes(title)
      })) excludeColumn = row;
      if (row && row === excludeColumn) return value;

      if (/^(\d+)(\.\d+)?$/.test(value) && unit != "cm") {
        value = value == 0 ? "0" : change(value);
      } else if (value == "" || value == null) {
        value = "&nbsp;";
      } else if (re1.test(value) && unit != "cm") {
        const res = re1.exec(value);
        value = `${change(res[1])}-${change(res[3])}`;
      }
    }

    function change(v) {
      return Math.round(v / d);
      // return Math.ceil(v / d)
    }

    return value;
  }
  function init() {
    const product_type = meta.product.type
    const video_map = window.size_guide_video_map?.[product_type]

    function makeVideoCover() {
      // 商品类型
      // 如果没有找到映射，返回空字符串
      if (!video_map?.video) return

      const video_inner = `
        <a
          id="size_guide_video-cover"
          href="#size_guide_video-popup"
          role="button"
          aria-label="Play size guide video"
          style="cursor: pointer; margin-bottom: 10px;"
        >
          <img class="video_cover lazyloadt4s t4s-lz--fadeIn t4s-d-none t4s-d-md-block" data-src="${video_map.cover?.pc}" alt="Size Guide Video Cover" />
          <img class="video_cover lazyloadt4s t4s-lz--fadeIn t4s-d-block t4s-d-md-none" data-src="${video_map.cover?.m}" alt="Size Guide Video Cover" />
        </a>
      `

      $(".mibao_size_guide_2022 .body .size_video_box").html(video_inner)
    }

    function initSizeGuideVideoPopup(videoUrl) {
      const eventNamespace = '.sizeGuideVideo'
      const $document = $(document)
      const $popup = $('#size_guide_video-popup').first()
      const video = $popup.find('#size_guide_video-player').get(0)

      if (!$popup.length || !video || !videoUrl) return

      function closeVideoPopup() {
        video.pause()

        try {
          video.currentTime = 0
        } catch (error) {
          console.warn('Failed to reset size guide video:', error)
        }

        $popup.hide().attr('aria-hidden', 'true')
      }

      $document
        .off('click' + eventNamespace, '#size_guide_video-cover')
        .on(
          'click' + eventNamespace,
          '#size_guide_video-cover',
          function (event) {
            event.preventDefault()

            if (video.dataset.src !== videoUrl) {
              video.src = videoUrl
              video.dataset.src = videoUrl
              video.loop = true
              video.load()
            }

            $popup.show().attr('aria-hidden', 'false')

            const playPromise = video.play()
            if (playPromise) {
              playPromise.catch(error => {
                console.warn('Failed to play size guide video:', error)
              })
            }

            window.Shopify?.analytics?.publish('auto_tracking', {
              type: 'click',
              element_id: 'size_guide_video-cover_manual'
            })
          }
        )

      $popup
        .off(eventNamespace)
        .on(
          'click' + eventNamespace,
          '.t4s-video-popup-wrapper, #size_guide_video-close',
          function (event) {
            event.preventDefault()
            closeVideoPopup()
          }
        )

      $document
        .off('keydown' + eventNamespace)
        .on('keydown' + eventNamespace, function (event) {
          if (event.key === 'Escape' && $popup.is(':visible')) {
            closeVideoPopup()
          }
        })

      closeVideoPopup()
    }

    makeVideoCover()
    initSizeGuideVideoPopup(video_map?.video)

    function renderAttributes() {
      let attributes_html = ''
      function make_attributes_html(operation_filter) {
        if (!operation_filter) {
          return ''
        }
        const stretchMapping = {
          "excellent stretch": 0,
          "great stretch": 0,
          "medium stretch": 50,
          "slight stretch": 100,
          "non-stretch": 100
        };

        const fitMapping = {
          "oversized fit": 0,
          "relaxed fit": 0,
          "regular fit": 50,
          "fitted": 100,
          "slim fit": 100
        };

        let htmlContent = '';

        // 安全获取并转换为小写，使用 operation_filter
        const currentStretch = operation_filter.stretch_type ? operation_filter.stretch_type.toLowerCase() : "";
        const currentFit = operation_filter.fit_type ? operation_filter.fit_type.toLowerCase() : "";

        // 检查并渲染 Stretchy 模块
        if (currentStretch && stretchMapping[currentStretch] !== undefined) {
          const position = stretchMapping[currentStretch];
          document.querySelector('.attributes-container #stretchy .thumb').style.left = `${position}%`
          document.querySelector('.attributes-container #stretchy').style.display = 'flex'
        }

        // 检查并渲染 Style (Fit) 模块
        if (currentFit && fitMapping[currentFit] !== undefined) {
          const position = fitMapping[currentFit];
          document.querySelector('.attributes-container #style .thumb').style.left = `${position}%`
          document.querySelector('.attributes-container #style').style.display = 'flex'
        }
      }

      attributes_html = make_attributes_html(operation_filter)
    }

    renderAttributes()

    function insertModelInfo() {
      $(".mibao_size_guide_2022 #model_info").html(metafieldData["size_guide_model_data"] || "");
    }
    insertModelInfo()

    if (!metafieldData["sizedata"]) {
      // sizeData没数据
      $(".mibao_size_guide_2022 .guide_table .header span").removeClass("hit");
      $(
        ".mibao_size_guide_2022 .guide_table .header span[type=product]"
      ).addClass("hit");
      $(".mibao_size_guide_2022 .guide_table .header span[type=body").hide();
    }
    $(".mibao_size_guide_2022 .guide_table .switch").click(function (e) {
      const unit = $(this).attr("unit");
      const newUnit = unit == "cm" ? "inch" : "cm";
      $(this).attr("unit", newUnit);
      $(this).find(".name").removeClass("hit");
      $(this).find(`.name.${newUnit}`).addClass("hit");
      makeTable();
    });
    $(".mibao_size_guide_2022 .guide_table .header span").click(function (e) {
      $(".mibao_size_guide_2022 .guide_table .header span").removeClass("hit");
      $(this).addClass("hit");
      makeInfo();
      makeTable();
    });
  }
  function makeInfo() {
    const type = $(".mibao_size_guide_2022 .guide_table .header .hit").attr(
      "type"
    );
    const product_types = meta.product.type.split(">");
    let info_type;
    if (type == "product") {
      // 上衣tops，连衣裙dress，裤装pants,shorts，半裙skirts，skorts
      if (/tops/i.test(product_types[1])) {
        info_type = "tops";
      } else if (/dresses/i.test(product_types[1])) {
        info_type = "dresses";
      } else if (
        /bottoms/i.test(product_types[1]) &&
        !/skirt/i.test(product_types[2])
      ) {
        info_type = "bottoms";
      } else if (/skirt/i.test(product_types[2])) {
        info_type = "skirts";
      }
    } else if (type == "body") {
      info_type = "body";
    }
    $(".mibao_size_guide_2022 .info").hide();
    if (info_type) {
      $(`.mibao_size_guide_2022 .info.${info_type}`).show();
    }
  }

  const current_country_code = window.ogl_size_config?.country || 'US'

  const size_info = window.initSizeInfo(window.size_guide_clicked_product)

  function getCountrySizeValue(size) {
    const sizeKey = String(size || '').trim()
    if (!sizeKey) return undefined
    return size_info?.country_size_json?.[sizeKey]?.[current_country_code]
  }

  function isCountrySizeTitle(value) {
    return exclude_title.includes(String(value || '').trim())
  }

  function makeCountrySizeLine(line, sizeData) {
    const sizeLine = sizeData.find(row => row.some(item => getCountrySizeValue(item) !== undefined))

    return line.map((item, index) => {
      if (isCountrySizeTitle(item)) return current_country_code

      const countrySizeValue = getCountrySizeValue(sizeLine?.[index])
      return countrySizeValue !== undefined ? countrySizeValue : item
    })
  }

  function splitSizeData(sizeData) {
    const splitIndexList = []
    sizeData.forEach((row, r) => {
      //通过判断是否是尺码来判断是否是尺码列
      if (row.includes("XS") || row.includes("S") || row.includes("M") || row.includes("L") || row.includes("XL") || row.includes("2XL")) {
        const index = r - 1 < 0 ? 0 : r - 1;
        splitIndexList.push(index);
      }
    })
    splitIndexList.push(sizeData.length)
    var sizeTables = []
    // 不止一个table
    if (splitIndexList.length > 2) {
      splitIndexList.forEach((ele, index) => {
        index < splitIndexList.length - 1 && sizeTables.push(sizeData.slice(ele, splitIndexList[index + 1]))
      })
    } else {
      sizeTables = [sizeData]
    }
    return sizeTables
  }

  function makeTable() {
    const type = $(".mibao_size_guide_2022 .guide_table .header .hit").attr(
      "type"
    );
    const unit = $(".mibao_size_guide_2022 .guide_table .switch").attr("unit");
    $(".mibao_size_guide_2022 .guide_table .switch").show(0);
    $(".mibao_size_guide_2022 .tips").show(0);
    let sizeData = [];
    // 按照尺码列分割数据列表
    let sizeTables = [];
    let needResize = true;
    if (type == "product" && metafieldData["sizedata"]) {
      const productSizeDataOrigin = metafieldData["sizedata"];
      console.log('productSizeDataOrigin', productSizeDataOrigin)
      sizeData = productSizeDataOrigin
        .split("\n")
        .filter((o) => o)
        .map((o, r) => o.split("|").map((v, c) => changeUnit(r, c, v, unit)));
      sizeData[0][0] = "&nbsp;";
      console.log('sizeData----', sizeData)

      // 将多个table分割
      sizeTables = splitSizeData(sizeData);
      console.log('sizeTables--------', sizeTables)
    } else if (type == "body") {
      sizeData = size_info.convertBodySizeTableUnit(unit, false)
      needResize = false;
    } else if (type == "size") {
      sizeData = [
        [
          "<span class='w'>weight<br><sub>(LBS)</sub></span><span class='h'>height</span><b>&nbsp<b>",
          "<100",
          "100",
          "120",
          "130",
          "140",
          "150",
          "160",
          "170",
          "180",
          "190",
          "200",
        ],
        ["5'1''", "XS", "S", "S", "S", "M", "M", "L", "L", "XL", "XXL", ""],
        ["5'2''", "XS", "XS", "S", "S", "M", "M", "L", "L", "XL", "XXL", ""],
        ["5'3''", "XS", "XS", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'4''", "XS", "XS", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'5''", "XS", "XS", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'6''", "XS", "S", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'7''", "", "S", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'8''", "", "", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'9''", "", "", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'10''", "", "", "S", "S", "M", "M", "M", "L", "L", "L", "XL"],
        ["5'11''", "", "", "M", "M", "M", "M", "M", "L", "L", "L", "XL"],
        ["6'0''", "", "", "M", "M", "M", "M", "M", "L", "L", "L", "XL"],
      ];
      needResize = false;
      $(".mibao_size_guide_2022 .guide_table .switch").hide(0);
    } else if (type == "country") {
      sizeData = size_info.country_size
      needResize = false;
      $(".mibao_size_guide_2022 .guide_table .switch").hide(0);
      $(".mibao_size_guide_2022 .tips").hide(0);
    }
    //覆盖sizeData,商品尺码表
    function makeTableHtml(sizeData) {
      let tableHtml = "";
      let tableFieldNameHtml = "";
      if (needResize) {
        // 数据转换，行列对调
        const sizeDataResize = [];
        for (let index in sizeData) {
          let line = sizeData[index];
          const countrySizeTitleLine = line.filter(item => isCountrySizeTitle(item))
          console.log('line.filter(item => (exclude_title.includes(item)))', countrySizeTitleLine)

          if (countrySizeTitleLine.length > 0) {
            line = makeCountrySizeLine(line, sizeData)
            sizeData[index] = line
          }

          for (let key in line) {
            if (sizeDataResize[key] == undefined) {
              sizeDataResize[key] = [];
            }
            sizeDataResize[key][index] = line[key] || "&nbsp;";
          }
        }
        sizeData = sizeDataResize;
      }

      // for(let item of sizeData){
      for (let item of sizeData) {
        let tmp = `<tr> <td>${item.slice(1).map(item => {
          return item
        }).join("</td><td>")}</td></tr>`;
        let tmp2 = `<tr><td>${item[0]}</td></tr>`;
        tableHtml += tmp;
        tableFieldNameHtml += tmp2;
      }
      tableHtml = `<div class="data"><table>${tableHtml}</table></div>`;
      tableFieldNameHtml = `<div class="fixed_header"><table>${tableFieldNameHtml}</table></div>`;

      return `<div class="content">${tableFieldNameHtml}${tableHtml}</div>`
    }

    function JoinTables() {
      let table_html_str = ''
      if (type != "product") {
        return `<div class="table-wrapper"> ${makeTableHtml(sizeData)}</div>`
      }
      for (let item of sizeTables) {
        console.log('itemsssss', item)
        let table_html = item
        let table_title = ''
        if (sizeTables.length >= 2) {
          console.log('item[0]', item[0])
          table_title = item[0].filter(item => !item.includes('&nbsp')).join('')
          table_html = item.slice(1)
          table_html[0][0] = table_title
        }
        table_html_str += `<div class="table-wrapper"> ${makeTableHtml(table_html)}</div>`;
      }
      return table_html_str
    }

    // 挂载表格
    $(".mibao_size_guide_2022 .guide_table .guide_table_body").html(JoinTables());

    // console.log(unit, sizeDataString, sizeData, tableHtml)

    $(".mibao_size_guide_2022 .tips span").hide();
    if (type == "size") {
      $(
        ".mibao_size_guide_2022 .guide_table .content .fixed_header table"
      ).addClass("size");
      $(".mibao_size_guide_2022 .guide_table .content .data table").addClass(
        "size"
      );
      $(".mibao_size_guide_2022 .tips span.size").show();
    } else {
      $(".mibao_size_guide_2022 .tips span.others").show();
    }
  }

  makeTable()
  makeInfo()
  MB_jsDeferHandle(init, ["jQuery"]);
})();
